import { combineEpics, Epic } from 'redux-observable';
import { validateRegexEpic } from '../claim/epics/validateRegex';
import validateClaimDataEpic from '../claim/epics/validateClaimData';
import redirectEpic from '../claim/epics/redirect';

const rootEpic = combineEpics(redirectEpic as Epic, validateRegexEpic as Epic, validateClaimDataEpic as Epic);

export default rootEpic;
